import { Link, useParams } from "react-router-dom";
import { useShop } from "@/store";
import { M, J, KAN, ARTICLE_BODY } from "@/data/catalogue";
import PageHd from "@/components/PageHd";
import { Reveal, MaskedLines } from "@/components/motion";
import { NotFound } from "@/pages/Misc";

function fmtDate(d, lang) {
  return new Date(d + "T12:00:00").toLocaleDateString(lang === "es" ? "es-CO" : "en-US", { month: "long", day: "numeric", year: "numeric" });
}

function readMins(id, lang) {
  const body = ARTICLE_BODY[lang]?.[id] || ARTICLE_BODY.en[id] || [];
  const words = body.join(" ").split(/\s+/).length;
  return Math.max(2, Math.round(words / 200));
}

export function Journal() {
  const { t, L, lang } = useShop();
  return (
    <>
      <PageHd eb={t("journal.eb")} h={t("journal.h")} testid="journal-title" />
      <div className="wrap grid g3" style={{ paddingBottom: 80 }} data-testid="journal-grid">
        {J.map((j, i) => (
          <Reveal key={j.id} delay={i * 0.06}>
            <Link className="jcard" to={`/journal/${j.id}`} data-testid={`journal-card-${j.id}`}>
              <div className="im"><img src={M[j.img]} alt={L(j).t} loading="lazy" /></div>
              <div className="eyebrow">{L(j).c} · {fmtDate(j.date, lang)} · {readMins(j.id, lang)} {t("journal.min")}</div>
              <h3>{L(j).t}</h3>
              <p>{L(j).s}</p>
            </Link>
          </Reveal>
        ))}
      </div>
    </>
  );
}

export function Article() {
  const { id } = useParams();
  const { t, L, lang } = useShop();
  const j = J.find((x) => x.id === id);
  if (!j) return <NotFound />;
  const body = (ARTICLE_BODY[lang] && ARTICLE_BODY[lang][id]) || ARTICLE_BODY.en[id];
  const [first, ...rest] = body;

  return (
    <>
      <div className="wrap" style={{ paddingTop: 40 }}>
        <Link className="btn ghost" to="/journal" data-testid="article-back">← {t("journal.back")}</Link>
      </div>
      <div className="wrap article">
        <Reveal className="hd">
          <div className="eyebrow">{L(j).c} · {fmtDate(j.date, lang)} · {readMins(id, lang)} {t("journal.min")}</div>
          <MaskedLines lines={[L(j).t]} testid="article-title" />
          <p className="lede" style={{ margin: "0 auto" }}>{L(j).s}</p>
        </Reveal>
      </div>
      <Reveal className="wrap bigimg" y={20}>
        <img src={M[j.img]} alt={L(j).t} style={{ marginBottom: 40 }} />
      </Reveal>
      <div className="wrap article" style={{ paddingBottom: 80 }} data-testid="article-body">
        <p>{first}</p>
        {id === "kanaas" && (
          <>
            <h2>{lang === "es" ? "Siete patrones" : "Seven patterns"}</h2>
            <table className="kantable">
              <tbody>
                {KAN.map((k) => (
                  <tr key={k[0]}>
                    <td>{k[0]}</td>
                    <td>{lang === "es" ? k[2] : k[1]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
        {rest.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
    </>
  );
}
